import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// import '../styles/ProductDetailPage.css'; // Add later

// Use environment variable for API base URL
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5050';

const ProductDetailPage = () => {
  const { handle } = useParams();

  // Redirect to Shopify product page
  window.location.href = `https://artemerge.org/products/${handle}`;

  return null; // No need to render anything as we're redirecting
};

export default ProductDetailPage; 